 export const departmentCodes = {
 
 
      ICT: "IT",
      HR: "HR",
      Kitchen: "KIT",
      "Front Office": "FO",
      Store: "ST",
      Account: "ACC",
      Audit: "AU",
      "F&B": "FB",
      "House keeping": "HK",
      Maintenance: "MA",
      Garden: "GA",
      Reservation: "RE",
      Resturant: "RST",
      Procurement: "PR",
      Reception: "REC",
      Laundry: "LA",
      Compliance: "COM",
      SPA: "SPA",
      GYM: "GY",
      Naturalist: "NAT",
      Yoga: "YG",
      Marketing: "MK",
      Admin: "AD",
      Transport: "TR",
      Safety: "SAF",
      SwimShop: "SS",
      DJ: "DJ",
      Outlet: "OUT",
      Production: "PROD"
    
    };


 


    
    
    
    
    
   
    
   
   
    
    
   
    
   
    
    
    